import { Stack } from '@mui/material';
import { NextPrevButton } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { BlueX } from 'Images';

interface IButtons {
  resetAndExit: () => void;
  onSubmit: () => void;
  isEdit: boolean;
}

export const Buttons = ({ resetAndExit, onSubmit, isEdit }: IButtons) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements).form;
  const isDesktop = useIsDesktop();

  return (
    <Stack
      sx={{
        alignItems: 'center',
        mt: 4,
        justifyContent: 'center',
        gap: '24px',
      }}
    >
      <NextPrevButton
        callback={() => {
          onSubmit();
        }}
        text={isEdit ? dictionary.editSave : dictionary.save}
        style={
          isDesktop
            ? undefined
            : {
                button: {
                  height: '36px',
                  width: isDesktop ? '244px' : '100%',
                },
                text: {
                  fontSize: '16px',
                  fontWeight: isDesktop ? '600' : '700',
                },
              }
        }
        isBlue
        isNext
      />
      <NextPrevButton
        callback={resetAndExit}
        text={dictionary.exit}
        style={
          isDesktop
            ? undefined
            : {
                button: {
                  height: '36px',
                  width: isDesktop ? '244px' : '100%',
                },
                text: {
                  fontSize: '16px',
                  fontWeight: isDesktop ? '600' : '700',
                },
              }
        }
        icon={{ src: BlueX, sx: { width: '20px', height: '20px', mb: '-2px' } }}
        hideArrowIcon
      />
    </Stack>
  );
};
